import React, { createContext, useContext, PropsWithChildren } from 'react'
const client = require('api/auth')

interface OrderAdjustmentsAPI {
  updateTime: (orderId: string, delay: number) => Promise<void>
}

const orderAdjustmentsAPI = createContext<OrderAdjustmentsAPI | null>(null)

export function OrderAdjustments(props: PropsWithChildren<{ svc: string }>): JSX.Element {
  const token = client.getAuthResponse() ? client.getAuthResponse().access_token : null
  const api: OrderAdjustmentsAPI = {
    updateTime: (orderId: string, delay: number): Promise<void> => {
      const payload = {duration: delay}
      return fetch(`${props.svc}/v5/orders/${orderId}/update_time`, {method: 'POST', headers: authJsonHeaders(token), body: JSON.stringify(payload)}).then(res => res.json())
    }
  }
  return <orderAdjustmentsAPI.Provider value={api}>{props.children}</orderAdjustmentsAPI.Provider>
}

export function useOrderAdjustmentsAPI() : OrderAdjustmentsAPI {
  const api = useContext(orderAdjustmentsAPI)
  return api as OrderAdjustmentsAPI
}

const authJsonHeaders = (token: string) => {
  return {
    'Content-Type': 'application/json',
    Authorisation: `Bearer ${token}`,
    Authorization: `Bearer ${token}`,
  }
}
